module.exports = __webpack_public_path__ + "static/TangleTower2-3c8e931461c796eb7fc392e02de8f1be.webp";